import React, { useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const DeletePopup = ({
  isOpen,
  onClose,
  staffName,
  staffId,
  isActive,
  fetchStaffData,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!isOpen) return null;

  const handleToggleStatus = async () => {
    setIsSubmitting(true)
    try {
      const newStatus = isActive ? "deactive" : "active";
      await apiService.put(`staff_users/${staffId}`, { status: newStatus });

      onClose();
      toast.success(
        `Staff ${staffName} has been ${
          isActive ? "deactivated" : "activated"
        }.`,
        { duration: 2000 }
      );

      fetchStaffData();
    } catch (errors) {
       handleError(errors);
    }finally{
      setIsSubmitting(false)
    }
  };

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
        <div className="bg-white rounded-lg p-6 w-[310px] sm:w-[350px] h-auto shadow-lg relative">
          <p className="text-lg font-semibold text-center mb-8">
            Are you sure you want to {isActive ? "deactivated" : "activated"}
            <span className="text-lg font-bold"> {staffName} </span>?
          </p>
          <div className="flex justify-center gap-4 mt-4">
            <button
              className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green"
              onClick={() => {
                onClose();
              }}
            >
              Close
            </button>
            <button
              onClick={() => {
                handleToggleStatus();
              }}
              type="button"
              className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${
                isSubmitting
                  ? "bg-green50 cursor-not-allowed"
                  : "bg-green text-white"
              }`}
              disabled={isSubmitting}
            >
             {isSubmitting ? "Confirming..." : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeletePopup;
